<terra-transactions-list
    [isLp]="parentType === UnitApplicationParentType.LP"

    [transactions]="pageRows$ | async"
    [exportTransactionsParameters]="{searchOptions: searchOptions$ | async, bankAccountId: bankAccountId, bankType: 'unit'}"
    [pageSize]="pageSize$ | async"
    [pageNumber]="pageNumber$ | async"
    [filter]="cardsTransactionsFilter$ | async"
    [totalTransactionsNumber]="totalRowsCount$ | async"
    [loading]="isLoading$" (onFilterChanged)="onFilterChanged($event)"
    
    (onDirectionChanged)="onDirectionChanged($event)"
    (onDateRangeChanged)="onDateRangeChanged($event)"
    (onPageSizeChanged)="onPageSizeChanged($event)"
    (onPageNumberChanged)="onPageNumberChanged($event)"
    (onExportSelected)="onExportSelected($event)"
/>
